<div class="wrapper">
  <div class="container-fluid">
    <!-- start page title -->
    <div class="row">
      <div class="col-12">
        <div class="page-title-box">
          <div class="page-title-right">
            <ol class="breadcrumb m-0">
              <li class="breadcrumb-item active">Custom Services Configuration</li>
            </ol>
          </div>
        </div>
      </div>
    </div>
    <!-- end page title -->

    <div class="row">
      <div class="col-12">
        <div class="card-box">
          <ul ngbNav #nav="ngbNav" class="nav nav-tabs">
            <li [ngbNavItem]="1">
              <a ngbNavLink>Custom Services Configuration</a>
              <ng-template ngbNavContent>
                <div class="form-group row">
                  <label for="ServiceType" class="col-3 col-form-label">Select a Merchant</label>
                  <div class="col-6">
                    <ng-select name="merchants" bindLabel="merchants" placeholder="List of merchants" [(ngModel)]="selectedMerchant" (change)="getServices($event)" [disabled]="updateAllMerchants" [searchable]="true" #merchantSelect>
                      <ng-option [value]="merchant.merchantNumber" *ngFor="let merchant of merchants">
                        ({{merchant.merchantNumber}}) {{merchant.nameLocation}}
                      </ng-option>
                    </ng-select>
                  </div>
                  <div class="col-3">
                    <div class="form-check">
                      <input mdbCheckbox class="form-check-input" type="checkbox" [(ngModel)]="updateAllMerchants" (change)="setUpdateAllMerchants($event)"/>
                      <label class="form-check-label" for="flexCheckDefault">Update all merchants</label>
                    </div>
                  </div>
                </div>
                <div class="form-group row">
                  <label for="ServiceType" class="col-3 col-form-label">Select a Service</label>
                  <div class="col-9">
                    <ng-select name="services" bindLabel="services" placeholder="List of Services" [(ngModel)]="selectedService" (change)="selectService($event)" [searchable]="true" #servicesSelect>
                      <ng-option [value]="service.id" *ngFor="let service of services">
                        {{service.name}}
                      </ng-option>
                    </ng-select>
                  </div>
                </div>
                <div class="form-group row">
                  <label for="ServiceType" class="col-3 col-form-label">API Key</label>
                  <div class="col-9">
                    <input type="text" [(ngModel)]="apiKey" id="apiKey" [name]="apiKey" [ngModelOptions]="{standalone: true}" 
                            placeholder="Api Key" class="form-control">
                  </div>
                </div>
                <div class="form-group mb-0 justify-content-end row">
                  <div class="col-9">
                    <button type="submit" [style]="buttonStatus" class="btn btn-info waves-effect waves-light float-right" (click)="addService()">
                      Add Service
                    </button>
                  </div>
                </div>
                <br>
                <div class="row">
                  <div class="col-12">
                    <table datatable [dtOptions]="dtOptions" [dtTrigger]="dtTrigger" class="table table-striped mb-0" style="width: 100%">
                      <thead>
                        <tr>
                          <th>Merchant</th>
                          <th>Service</th>
                          <th>API Key</th>
                          <th>&nbsp;</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr scope="col" *ngFor="let s of customServices">
                          <td>{{s.merchantNumber}}</td>
                          <td>{{s.service.name}}</td>
                          <td>
                            {{s.apiKey}}
                          </td>
                          <td class="w-25">
                            <div class="d-flex flex-row justify-content-end">
                              <button type="button"
                                      class="btn btn-icon waves-effect waves-light btn-outline-primary "
                                      (click)="viewAPIKey(s.apiKey)"> View
                              </button>

                              <button type="button"  [style]="buttonStatus"
                                      class="btn btn-icon waves-effect waves-light btn-outline-danger "
                                      (click)="deleteService(s.service.id,s.merchantNumber)">
                                      <i class="mdi mdi-delete"></i> Delete 
                              </button>
                            </div>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
              </ng-template>
            </li>
            <li [ngbNavItem]="2">
              <a ngbNavLink>Service Setup</a>
              <ng-template ngbNavContent>
                <form class="form-horizontal" role="form" autocomplete="off">
                  <div class="form-group row">
                    <label for="ServiceType" class="col-3 col-form-label">Service Name</label>
                    <div class="col-9">
                      <input [(ngModel)]="serviceInput" [ngModelOptions]="{standalone: true}" id="merchantNumber" required class="form-control">
                    </div>
                  </div>
                  <div class="form-group mb-0 justify-content-end row">
                    <div class="col-9">
                      <button type="submit" class="btn btn-info waves-effect waves-light float-right" (click)="addNewService()">
                        <span *ngIf="!updateAllMerchants">Add Service</span>
                        <span *ngIf="updateAllMerchants">Add Services</span>
                      </button>
                    </div>
                  </div>
                </form>
                <br>
                <div class="row">
                  <div class="col-12">
                    <table class="table table-striped">
                      <thead>
                        <tr>
                          <th>Service</th>
                          <th>&nbsp;</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr scope="col" *ngFor="let s of allServices">
                          <td>{{s.name}}</td>
                          <td>
                            <button type="button"
                                    class="btn btn-icon waves-effect waves-light btn-outline-danger fa-pull-right"
                                    (click)="removeService(s.id)">
                              Delete <i class="mdi mdi-delete"></i>
                            </button>
                            <button type="button"
                                    class="btn btn-icon waves-effect waves-light btn-outline-primary fa-pull-right"
                                    (click)="editService(s.id)">
                              Edit <i class="mdi mdi-pencil"></i>
                            </button>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
              </ng-template>
            </li>
            <li [ngbNavItem]="3">
              <a ngbNavLink>Service Parameter Setup</a>
              <ng-template ngbNavContent>
                <form class="form-horizontal" role="form" autocomplete="off">
                  <div class="form-group row">
                    <label for="serviceParameter" class="col-3 col-form-label">Parameter</label>
                    <div class="col-9">
                      <input [(ngModel)]="serviceParameterInput" [ngModelOptions]="{standalone: true}" id="serviceParameter" required class="form-control">
                    </div>
                  </div>
                  <div class="form-group row">
                    <label for="parameterService" class="col-3 col-form-label">Link to Service</label>
                    <div class="col-9">
                      <ng-select name="parameterService" bindLabel="parameterService" placeholder="List of Services" [(ngModel)]="linkedService" (change)="linkServiceChange($event)" [searchable]="true" #parameterService>
                        <ng-option [value]="service.id" *ngFor="let service of unlinkedServices">
                          {{service.name}}
                        </ng-option>
                      </ng-select>
                    </div>
                  </div>
                  <div class="form-group mb-0 justify-content-end row">
                    <div class="col-9">
                      <button type="submit" class="btn btn-info waves-effect waves-light float-right" (click)="addServiceParameter()">
                        Add Service Parameter
                      </button>
                    </div>
                  </div>
                </form>
                <br>
                <div class="row">
                  <div class="col-12">
                    <table class="table table-striped">
                      <thead>
                        <tr>
                          <th>Parameter</th>
                          <th>Service</th>
                          <th>&nbsp;</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr scope="col" *ngFor="let sp of serviceParameters">
                          <td>{{sp.name}}</td>
                          <td>{{sp.service.name}}</td>
                          <td>
                            <button type="button"
                                    class="btn btn-icon waves-effect waves-light btn-outline-danger fa-pull-right"
                                    (click)="removeServiceParameter(sp.id)">
                              Delete <i class="mdi mdi-delete"></i>
                            </button>
                            <button type="button"
                                    class="btn btn-icon waves-effect waves-light btn-outline-primary fa-pull-right"
                                    (click)="editServiceParameter(sp.id)">
                              Edit <i class="mdi mdi-pencil"></i>
                            </button>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
              </ng-template>
            </li>
          </ul>
          <div [ngbNavOutlet]="nav" class="tab-pane"></div>
        </div>
      </div>
    </div>
  </div>
</div>
